import { cartesianToPolar } from './geometry';

export default function donutChartInteraction({
  onStart,
  onEnd,
  getSize,
  distanceMin,
  distanceMax,
  onSelectAngle,
}) {
  function polarFromEvent(event) {
    const boundingRect = event.currentTarget.getBoundingClientRect();
    const size2 = getSize() / 2;
    const x = event.clientX - boundingRect.left - size2;
    const y = event.clientY - boundingRect.top - size2;

    return cartesianToPolar(x, y);
  }

  let lastAngle;
  let hasMoved;

  return {
    onMouseDown(event) {
      const { radius, rads } = polarFromEvent(event);
      // if (radius >= distanceMin() && radius <= distanceMax()) {
        lastAngle = rads;
        hasMoved = false;
        onSelectAngle(lastAngle);
        // onStart();
      // }
    },
    onMouseUp() {
      if (typeof lastAngle === 'number') {
        // onEnd();
        if (!hasMoved) {
          console.log('OnSelect Angle')
          onSelectAngle(lastAngle);
        }

        lastAngle = null;
      }
    },
  };
}
